import { render, staticRenderFns } from "./RightSideWeixin.vue?vue&type=template&id=1c51db78&scoped=true&"
import script from "./RightSideWeixin.vue?vue&type=script&lang=js&"
export * from "./RightSideWeixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c51db78",
  null
  
)

export default component.exports